import type { Filter } from './filters';

export const fixEqEmptyFilter = (filter: Filter): Filter => {
  if (filter[filter.length - 1] === null) {
    if (['eq', 'ieq'].includes(filter[filter.length - 2] as string)) {
      return [...(filter.slice(0, filter.length - 2) as Filter), 'empty', true];
    }
    if (['neq', 'nieq'].includes(filter[filter.length - 2] as string)) {
      return [
        ...(filter.slice(0, filter.length - 2) as Filter),
        'empty',
        false,
      ];
    }
  }

  return filter;
};
